import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowLeftDownCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-left-down-circle"} maskId="square-filled-radius-0-stroke-1-IconArrowLeftDownCircle"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM8 16H15V15H9.70711L16.2071 8.5L15.5 7.79289L9 14.2929V9H8V16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowLeftDownCircle;
